import gql from 'graphql-tag';

import {
    officePlace,
    organisationInfo,
    organisationLicensePaymentAddress,
    organisationOffice,
    organisationTariff,
    user,
    userConfig,
} from '../fragments';

export const createOrganisation = gql`
    mutation CreateOrganisation($input: CreateOrganisationInput!) {
        createOrganisation(input: $input) {
            organisation {
                ...OrganisationInfo
                offices {
                    ...OrganisationOfficeFragment
                }
            }
            confirmationToken
        }
    }
    ${organisationInfo}
    ${organisationOffice}
`;

export const createOrganisationOnboarding = gql`
    mutation CreateOrganisationOnboarding($input: OrganisationOnboardingInput!) {
        createOrganisationOnboarding(input: $input) {
            user {
                ...UserFragment
                userConfig {
                    ...ConfigFragment
                }
            }
            office {
                ...OrganisationOfficeFragment
            }
            place {
                ...OfficePlaceFragment
            }
        }
    }
    ${user}
    ${userConfig}
    ${organisationOffice}
    ${officePlace}
`;

export const createOrganisationForCompletedUser = gql`
    mutation CreateOrganisationForCompletedUser($input: OrganisationForCompletedUserInput!) {
        createOrganisationForCompletedUser(input: $input) {
            user {
                ...UserFragment
                userConfig {
                    ...ConfigFragment
                }
            }
            office {
                ...OrganisationOfficeFragment
            }
            place {
                ...OfficePlaceFragment
            }
        }
    }
    ${user}
    ${userConfig}
    ${organisationOffice}
    ${officePlace}
`;

export const updateOrganisationLicense = gql`
    mutation UpdateOrganisationLicense($officeId: Int!, $organisationId: Int!, $updatedTariffStatus: String!) {
        updateOrganisationLicense(
            officeId: $officeId
            organisationId: $organisationId
            updatedTariffStatus: $updatedTariffStatus
        ) {
            ...OrganisationTariffFragment
        }
    }
    ${organisationTariff}
`;

export const updateOrganisationById = gql`
    mutation UpdateOrganisationById($organisationId: Int!, $input: UpdateOrganisationInput!) {
        updateOrganisationById(organisationId: $organisationId, input: $input) {
            ...OrganisationInfo
            offices {
                ...OrganisationOfficeFragment
            }
            organisationTariff {
                ...OrganisationTariffFragment
            }
            licensePaymentAddress {
                ...OrganisationLicensePaymentAddressFragment
            }
        }
    }
    ${organisationInfo}
    ${organisationOffice}
    ${organisationTariff}
    ${organisationLicensePaymentAddress}
`;

export const removeOrganisationById = gql`
    mutation RemoveOrganisationById($organisationId: Int!) {
        removeOrganisationById(organisationId: $organisationId) {
            idFromCache
            success
        }
    }
`;
